module.exports = __webpack_public_path__ + "static/media/QC.4826bdb7.svg";